import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { PositionState } from './model';
import { getGovernmentLevel, getJurisdiction, getPositions, getRace } from './thunks';

const initialState: PositionState = {
  governmentLevel: [],
  race: [],
  jurisdiction: [],
  position: [],
};

const positionSlice = createSlice({
  name: '@position',
  initialState,
  reducers: {
    setGovernmentLevel: (state, action: PayloadAction<PositionState['governmentLevel']>) => {
      state.governmentLevel = action.payload;
    },
    setJurisdiction: (state, action: PayloadAction<PositionState['jurisdiction']>) => {
      state.jurisdiction = action.payload;
    },
    setRace: (state, action: PayloadAction<PositionState['race']>) => {
      state.race = action.payload;
    },
    setPositions: (state, action: PayloadAction<PositionState['position']>) => {
      state.position = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getGovernmentLevel.fulfilled, (state, action) => {
      state.governmentLevel = action.payload;
    });
    builder.addCase(getJurisdiction.fulfilled, (state, action) => {
      state.jurisdiction = action.payload;
    });
    builder.addCase(getRace.fulfilled, (state, action) => {
      state.race = action.payload;
    });
    builder.addCase(getPositions.fulfilled, (state, action) => {
      state.position = action.payload;
    });
  },
});

export { getGovernmentLevel, getJurisdiction, getPositions, getRace } from './thunks';
export const { setGovernmentLevel, setJurisdiction, setRace, setPositions } = positionSlice.actions;
export default positionSlice.reducer;
